if (!customElements.get("variant-selects")) {
  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === "true";
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener("change", this.onVariantChange);
      this.sizeGuideTrigger = this.querySelector("[data-size-guide-trigger]");
      this.other = Array.from(
        document.querySelectorAll("variant-selects"),
      ).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest(".thb-product-detail");
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector(
          `#MediaGallery-${this.dataset.section}`,
        );
        this.hideVariants = this.productSlider.dataset.hideVariants === "true";
      }

      const sizeGuideDrawer = document.querySelector(
        "[data-size-guide-drawer]",
      );
      const sizeGuideDrawerClose = sizeGuideDrawer.querySelector(
        "[data-close-size-guide]",
      );

      if (sizeGuideDrawerClose) {
        sizeGuideDrawerClose.addEventListener("click", (e) => {
          sizeGuideDrawer.classList.remove("active");
          document.body.classList.remove("open-cc");
        });
      }

      if (this.sizeGuideTrigger) {
        this.sizeGuideTrigger.addEventListener("click", (e) => {
          sizeGuideDrawer.classList.add("active");
          document.body.classList.toggle("open-cc");
        });
      }

      this.sizeConversionEl = this.querySelector(
        "[data-size-conversion-group]",
      );

      if (this.sizeConversionEl) {
        this.sizeConversionData = JSON.parse(this.sizeConversionEl.textContent);
        this.regionSizingSelect = this.querySelector(
          "[data-region-size-select]",
        );
        this.sizeLabels = this.querySelectorAll("[data-size-option] span");

        this.sizeLabels.forEach((label) => {
          label.dataset.originalSize = label.textContent;
        });

        if (this.regionSizingSelect) {
          this.regionSizingSelect.addEventListener("change", (event) => {
            event.stopPropagation();
            this.updateSizes();
          });
        }
      }

      this.colorLabel = this.querySelector(
        ".product-form__input--color .form__label__value",
      );
      this.swatches = this.querySelectorAll("[data-color-name]");
      this.labelTimer = null;
      // Bind event handlers.
      this.handleSwatchMouseover = this.handleSwatchMouseover.bind(this);
      this.handleSwatchMouseout = this.handleSwatchMouseout.bind(this);
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();

      this.swatches?.forEach((swatch) => {
        swatch.addEventListener("mouseover", this.handleSwatchMouseover);
        swatch.addEventListener("mouseout", this.handleSwatchMouseout);
      });
    }

    disconnectedCallback() {
      this.swatches?.forEach((swatch) => {
        swatch.removeEventListener("mouseover", this.handleSwatchMouseover);
        swatch.removeEventListener("mouseout", this.handleSwatchMouseout);
      });
    }

    handleSwatchMouseover(e) {
      const colorName = e.currentTarget.textContent;
      const trimmedColorName = colorName.trim();
      if (!trimmedColorName) return;
      // Prevent swatch label from changing back to active color.
      clearTimeout(this.labelTimer);
      this.colorLabel.textContent = trimmedColorName;
    }

    handleSwatchMouseout() {
      const activeColor = Array.from(this.swatches).find((swatch) =>
        swatch.classList.contains("active"),
      );
      const colorName = activeColor.textContent;
      const trimmedColorName = colorName.trim();
      if (!trimmedColorName) return;
      // Give user a moment to hover over another swatch to prevent flickering.
      this.labelTimer = setTimeout(() => {
        this.colorLabel.textContent = trimmedColorName;
      }, 150);
    }

    updateSizes() {
      const selectedRegion = this.regionSizingSelect.value;

      this.sizeLabels.forEach((label) => {
        const auSize = label.dataset.originalSize;

        if (
          this.sizeConversionData[auSize] &&
          this.sizeConversionData[auSize][selectedRegion]
        ) {
          const newSize = this.sizeConversionData[auSize][selectedRegion];
          label.textContent = newSize;
        }
      });
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(false);
      this.updatePreorderMessage();
      this.updateSellingPlans();
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.updateWishlist();
      this.updateSaved();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(false);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();

        const sizeErrorEl = document.querySelector(".product__size-error");
        sizeErrorEl?.classList.remove("is-visible");
      }
      this.updateOther();

      dispatchCustomEvent("product:variant-change", {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector("select")) {
          this.options.push(fieldset.querySelector("select").value);
          this.option_keys.push(fieldset.querySelector("select").name);
        } else if (fieldset.querySelectorAll("input").length) {
          this.options.push(fieldset.querySelector("input:checked")?.value);
          this.option_keys.push(fieldset.querySelector("input").name);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector(".form__label__value");
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateWishlist() {
      if (!this.currentVariant) return;

      const section = document.querySelector(
        `#shopify-section-${this.dataset.section}`,
      );
      if (!section) return;

      section.querySelectorAll("[data-add-to-wishlist]").forEach((element) => {
        element.dataset.wishlistProductVariantId = this.currentVariant.id;
      });
    }
    updateSaved() {
      if (!this.currentVariant) return;

      const saveDesignButton = document.getElementById(
        `save-design-button-${this.dataset.section}`,
      );
      if (!saveDesignButton) return;

      saveDesignButton.dataset.productVariantId = this.currentVariant.id;
      saveDesignButton.update();
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === "false") {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll("fieldset"),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector("select")) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll("input").length) {
            fieldsets_array[i].querySelector(
              `input[value="${option}"]`,
            ).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
        this.other[0].setImageSetMedia();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(
        `[data-media-id="${mediaId}"]`,
      );

      this.productSlider
        .querySelectorAll("[data-media-id]")
        .forEach((element) => {
          element.classList.remove("is-active");
        });

      this.setImageSetMedia();

      activeMedia.classList.add("is-active");

      activeMedia.parentElement.prepend(activeMedia);

      window.setTimeout(() => {
        activeMedia.parentElement.scrollTo({
          left: 0,
          top: 0,
          behavior: "smooth",
        });
      });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      const url = new URL(window.location.href);
      url.searchParams.set("variant", this.currentVariant.id);
      window.history.replaceState({}, "", url.toString());
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}`,
      );
      if (!shareButton) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`,
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector(
        ".pickup-availability-wrapper",
      );

      if (!pickUpAvailability) return;

      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--sticky`,
        `add-to-cart-price-${this.dataset.section}`,
        `product-selected-options-${this.dataset.section}`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`,
        `notify-me-${this.dataset.section}`,
      ];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`,
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + "--sticky");

            if (price) price.classList.remove("visibility-hidden");
            if (price_fixed) price_fixed.classList.remove("visibility-hidden");
          });
          this.toggleAddButton(
            this.currentVariant.available,
            this.currentVariant.preorder,
            this.currentVariant.made_to_order,
            window.theme.variantStrings.soldOut,
          );
          this.updatePreorderMessage(
            this.currentVariant.selling_plan_description,
          );
          this.updateSellingPlans(
            this.currentVariant.selling_plan_id,
            this.currentVariant.made_to_order,
            this.currentVariant.fulfilment_date,
            this.currentVariant.submarine_campaign_name,
          );
          window.Currency?.convertAll?.();

          dispatchCustomEvent("variantChangeSectionsRendered", {
            detail: this.dataset.section,
          });
        });
    }

    toggleAddButton(
      available = false,
      preorder = false,
      madeToOrder = false,
      text = "",
    ) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`,
      );
      if (!productForm) return;

      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button",
      );

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text",
        );

        if (!submitButtonText) return;

        if (!available) {
          submitButton.setAttribute("disabled", "disabled");
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute("disabled");
          submitButton.classList.remove("loading");
          if (madeToOrder) {
            submitButtonText.textContent =
              window.theme.variantStrings.madeToOrder;
          } else if (preorder) {
            submitButtonText.textContent = window.theme.variantStrings.preorder;
          } else {
            submitButtonText.textContent =
              window.theme.variantStrings.addToCart;
          }
        }
      });
    }

    updatePreorderMessage(sellingPlanDescription) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`,
      );
      if (!productForm) return;

      const preorderMessage = productForm.querySelector(
        "[data-product-preorder-message]",
      );
      if (!preorderMessage) return;

      if (sellingPlanDescription) {
        preorderMessage.textContent = sellingPlanDescription;
        preorderMessage.classList.remove("hidden");
        return;
      }

      preorderMessage.classList.add("hidden");
      preorderMessage.textContent = "";
    }

    updateSellingPlans(
      sellingPlanId,
      isMadeToOrder,
      fulfilmentDate = "true",
      preorderCampaignName = "",
    ) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`,
      );
      if (!productForm) return;

      const sellingPlanElement = productForm.querySelector(
        'input[name="selling_plan"]',
      );
      const preorderPropertyElement = productForm.querySelector(
        'input[name="properties[_pre_order]"]',
      );
      const preorderCampaignNamePropertyElement = productForm.querySelector(
        'input[name="properties[_pre_order_campaign_name]"]',
      );
      const madeToOrderPropertyElement = productForm.querySelector(
        'input[name="properties[_made_to_order]"]',
      );
      const madeToOrderCampaignNamePropertyElement = productForm.querySelector(
        'input[name="properties[_made_to_order_campaign_name]"]',
      );

      if (!sellingPlanId) {
        sellingPlanElement?.remove();
        preorderPropertyElement?.remove();
        preorderCampaignNamePropertyElement?.remove();
        madeToOrderPropertyElement?.remove();
        madeToOrderCampaignNamePropertyElement?.remove();
        return;
      }

      if (sellingPlanElement) {
        sellingPlanElement.value = sellingPlanId;
      } else {
        const sellingPlanInput = document.createElement("input");
        sellingPlanInput.type = "hidden";
        sellingPlanInput.name = "selling_plan";
        sellingPlanInput.value = sellingPlanId;
        productForm.appendChild(sellingPlanInput);
      }

      if (isMadeToOrder) {
        preorderPropertyElement?.remove();
        preorderCampaignNamePropertyElement?.remove();
        if (madeToOrderPropertyElement) {
          madeToOrderPropertyElement.value = fulfilmentDate;
          madeToOrderCampaignNamePropertyElement.value = preorderCampaignName;
        } else {
          const madeToOrderInput = document.createElement("input");
          madeToOrderInput.type = "hidden";
          madeToOrderInput.name = "properties[_made_to_order]";
          madeToOrderInput.value = fulfilmentDate;
          productForm.appendChild(madeToOrderInput);
          const madeToOrderCampaignNameInput = document.createElement("input");
          madeToOrderCampaignNameInput.type = "hidden";
          madeToOrderCampaignNameInput.name =
            "properties[_made_to_order_campaign_name]";
          madeToOrderCampaignNameInput.value = preorderCampaignName;
          productForm.appendChild(madeToOrderCampaignNameInput);
        }
      } else {
        madeToOrderPropertyElement?.remove();
        madeToOrderCampaignNamePropertyElement?.remove();
        if (preorderPropertyElement) {
          preorderPropertyElement.value = fulfilmentDate;
          preorderCampaignNamePropertyElement.value = preorderCampaignName;
        } else {
          const preorderInput = document.createElement("input");
          preorderInput.type = "hidden";
          preorderInput.name = "properties[_pre_order]";
          preorderInput.value = fulfilmentDate;
          productForm.appendChild(preorderInput);
          const preorderCampaignNameInput = document.createElement("input");
          preorderCampaignNameInput.type = "hidden";
          preorderCampaignNameInput.name =
            "properties[_pre_order_campaign_name]";
          preorderCampaignNameInput.value = preorderCampaignName;
          productForm.appendChild(preorderCampaignNameInput);
        }
      }
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button",
      );
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(
        `price-${this.dataset.section}--sticky`,
      );

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text",
        );
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add("sold-out");
      });
      if (price) price.classList.add("visibility-hidden");
      if (price_fixed) price_fixed.classList.add("visibility-hidden");
    }

    setDisabled() {
      if (this.isDisabledFeature != "true") {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data) {
        const selected_options =
          this.currentVariant?.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`,
            };
          }) ?? [];

        const available_options = this.createAvailableOptionsTree(
          variant_data,
          selected_options,
        );

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector("select")) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]",
                  ).disabled = true;
                } else {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]",
                  ).disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll("input").length) {
              fieldset.querySelectorAll("input").forEach((input, input_i) => {
                input.classList.toggle(
                  "is-disabled",
                  fieldset_options[input_i].isUnavailable,
                );
              });
            }
          }
        });
      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector("[data-set-name]");
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector(
          '.product-form__input[data-handle="' + this.imageSetName + '"]',
        ).dataset.index;

        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(
        this.currentVariant[this.imageSetIndex],
      );
      let group = this.imageSetName + "_" + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(
        `[data-set-name="${this.imageSetName}"]`,
      );

      if (this.hideVariants) {
        selected_set_images.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });
      } else {
        let set_images = Array.from(selected_set_images).filter(
          function (element) {
            return element.dataset.group === group;
          },
        );
        set_images.forEach((thumb) => {
          thumb.parentElement.prepend(thumb);
        });
      }
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            let entry = options[index].find(
              (option) => option.value === variant[index],
            );

            if (typeof entry === "undefined") {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }

            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent = selected_options.reduce(
              (count, { value, index }) => {
                return variant[index] === value ? count + 1 : count;
              },
              0,
            );

            // Only enable an option if an available variant matches all but one current selected value
            if (
              countVariantOptionsThatMatchCurrent >=
              selected_options.length - 1
            ) {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }

            // Make sure if a variant is unavailable, disable currently selected option
            if (
              (!this.currentVariant || !this.currentVariant.available) &&
              selected_options.find(
                (option) =>
                  option.value === entry.value && index === option.index,
              )
            ) {
              entry.isUnavailable = true;
            }

            // First option is always enabled
            if (index === "option1") {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }
          });

          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        },
      );
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        this.mergeVariantData(
          JSON.parse(
            this.querySelector("[data-variant-data]")?.textContent ?? "[]",
          ),
          JSON.parse(
            this.querySelector("[data-variant-preorder-data]")?.textContent ??
              "[]",
          ),
        );
      return this.variantData;
    }

    mergeVariantData(variantData, variantPreorderData) {
      return variantData.map((variant, index) => {
        return {
          ...variant,
          ...variantPreorderData[index],
        };
      });
    }
  }
  customElements.define("variant-selects", VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked,
        ).value;
      });
    }
  }

  customElements.define("variant-radios", VariantRadios);
}
if (!customElements.get("product-slider")) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector(
        ".product-images-buttons",
      );
      this.sliderDots = this.parentElement.querySelector(
        ".product-images-dots",
      );
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ["class"],
        childList: true,
        characterData: false,
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.addEventListener("scroll", this.updatePagination.bind(this));
        const resizeObserver = new ResizeObserver((entries) =>
          this.onPaginationResize(),
        );
        resizeObserver.observe(this);
      }

      // Start Slider Dots
      if (this.sliderDots) {
        this.setupSliderDots();
        this.addEventListener("scroll", this.updateSliderDots.bind(this));
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll(".product-single__media-zoom").length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector(".product-single__media-zoom");
        return {
          src: activelink.getAttribute("href"),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute("title"),
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(
          this.querySelectorAll(".product-images__slide--image"),
        ).filter((element) => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll(".pswp")[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true,
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest(".product-images__slide");
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest(".product-single__media"),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width,
          };
        };
        if (typeof PhotoSwipe !== "undefined") {
          let pswp = new PhotoSwipe(
            pswpElement,
            PhotoSwipeUI_Default,
            items,
            options,
          );

          pswp.listen("firstUpdate", () => {
            pswp.listen("parseVerticalMargin", function (item) {
              item.vGap = {
                top: 50,
                bottom: 50,
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll(".product-single__media-zoom").forEach(
        function (link) {
          let thumbnail = link.closest(".product-single__media");
          let clone = link.cloneNode(true);
          thumbnail.append(clone);
          link.remove();
          clone.addEventListener("click", (e) =>
            openPswp(e, clone, options, pswpElement, items),
          );
        },
      );
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientWidth > 0,
      );
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector(
        ".slider-counter--current",
      );
      this.pageTotalElement = this.pagination.querySelector(
        ".slider-counter--total",
      );

      this.prevButton = this.pagination.querySelector(
        'button[name="previous"]',
      );
      this.nextButton = this.pagination.querySelector('button[name="next"]');

      this.prevButton.addEventListener(
        "click",
        this.onPaginationButtonClick.bind(this),
      );
      this.nextButton.addEventListener(
        "click",
        this.onPaginationButtonClick.bind(this),
      );

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientWidth > 0,
      );
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft;
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.scrollLeft + 1 * this.sliderItemOffset
          : this.scrollLeft - 1 * this.sliderItemOffset;
      this.scrollTo({
        left: this.slideScrollPosition,
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage =
        Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          }),
        );
      }

      if (
        this.isSlideVisible(this.sliderItemsToShow[0]) &&
        this.scrollLeft === 0
      ) {
        this.prevButton.setAttribute("disabled", "disabled");
      } else {
        this.prevButton.removeAttribute("disabled");
      }

      if (
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
        )
      ) {
        this.nextButton.setAttribute("disabled", "disabled");
      } else {
        this.nextButton.removeAttribute("disabled");
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
        element.offsetLeft >= this.scrollLeft
      );
    }
    setupSliderDots() {
      this.currentPage =
        Math.round(this.scrollLeft / this.sliderItemOffset) + 1;
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientWidth > 0,
      );
      if (this.sliderItemsToShow.length < 2 || !this.sliderDots) return;

      this.sliderItemsToShow.forEach((element, index) => {
        const dot = document.createElement("button");
        dot.classList.add("product-images-dots--dot");
        dot.setAttribute("aria-label", `Slide ${index + 1}`);
        this.sliderDots.appendChild(dot);
      });

      const dots = this.sliderDots.querySelectorAll(
        ".product-images-dots--dot",
      );
      dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          this.scrollTo({
            left: this.sliderItemsToShow[index].offsetLeft,
            behavior: "smooth",
          });
        });
      });
      dots[this.currentPage - 1]?.classList?.add("is-active");
      return dots;
    }
    updateSliderDots() {
      const dots = this.sliderDots.querySelectorAll(
        ".product-images-dots--dot",
      );
      dots.forEach((dot) => dot.classList.remove("is-active"));
      dots[this.currentPage - 1].classList.add("is-active");
    }
  }
  customElements.define("product-slider", ProductSlider);
}
if (!customElements.get("product-thumbnails")) {
  /**
   *  @class
   *  @function ProductThumbnails
   */
  class ProductThumbnails extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const links = this.querySelectorAll("a");
      links.forEach((link) => {
        link.addEventListener("click", this.onThumbnailClick.bind(this));
      });
    }
    onThumbnailClick(event) {
      event.preventDefault();

      const href = event.currentTarget.getAttribute("href");
      if (!href) return;

      const slide = document.querySelector(href);
      if (!slide) return;

      const mediaGallery = slide.closest(".gallery-with-thumbs");
      if (!mediaGallery) return;

      mediaGallery.scrollTo({
        top: slide.offsetTop,
        behavior: "smooth",
      });
    }
  }
  customElements.define("product-thumbnails", ProductThumbnails);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.sticky = this.dataset.sticky;
        this.form = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        this.form.querySelector("[name=id]").disabled = false;
        if (!this.sticky) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }

        this.cartNotification = document.querySelector("cart-notification");
        this.body = document.body;

        this.hideErrors = this.dataset.hideErrors === "true";

        this.initGiftCardFields();

        this.updateNotifyForm();
        document.addEventListener("variantChangeSectionsRendered", (event) => {
          this.updateNotifyForm();
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.form.reportValidity()) {
          return;
        }
        const submitButtons = document.querySelectorAll(
          ".single-add-to-cart-button",
        );

        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains("loading")) return;
          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
        });

        this.handleErrorMessage();

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        };
        let formData = new FormData(this.form);

        const variantId = formData.get("id");
        const sizeErrorEl = document.querySelector(".product__size-error");

        if (variantId) {
          sizeErrorEl?.classList.remove("is-visible");
        } else {
          sizeErrorEl?.classList.add("is-visible");
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
          });
          return;
        }

        formData.append(
          "sections",
          this.getSectionsToRender().map((section) => section.section),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              dispatchCustomEvent("product:variant-error", {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              return;
            }

            this.renderContents(response);

            dispatchCustomEvent("cart:item-added", {
              product: response.hasOwnProperty("items")
                ? response.items[0]
                : response,
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
            });
          });
      }

      initGiftCardFields() {
        const nameFields = this.form.querySelectorAll(
          "[name='properties[sender_name]'], [name='properties[receiver_name]']",
        );

        nameFields.forEach((field) => {
          this.handleGiftCardFieldInput(field);
          field.addEventListener("input", () =>
            this.handleGiftCardFieldInput(field),
          );
        });
      }

      handleGiftCardFieldInput(target) {
        const errorField = target.closest(".field");
        if (!errorField) return;

        const errorMessage = errorField.querySelector(".error-message");
        if (!errorMessage) return;

        if (target.value.length > 50) {
          errorField.classList.add("has-error");
          target.classList.add("invalid");
          target.setCustomValidity(target.dataset.errorMessage);
          errorMessage.textContent = target.validationMessage;
        } else {
          errorField.classList.remove("has-error");
          target.classList.remove("invalid");
          target.setCustomValidity("");
          errorMessage.textContent = "";
        }
      }

      updateNotifyForm() {
        const notifyForm = document.querySelector(
          `#notify-me-${this.dataset.section} form`,
        );
        if (notifyForm) {
          // If the form is visible, add the event listener
          notifyForm.removeEventListener(
            "submit",
            this.handleNotifyFormSubmission,
          );
          notifyForm.addEventListener(
            "submit",
            this.handleNotifyFormSubmission,
          );
          notifyForm.removeEventListener("input", this.handleNotifyFormInput);
          notifyForm.addEventListener("input", this.handleNotifyFormInput);
        }
      }

      handleNotifyFormSubmission(evt) {
        evt.preventDefault();

        const notifyMeElementWrapper = document.querySelector(".notify-me");
        if (!notifyMeElementWrapper) return;

        const PUBLIC_API_KEY = notifyMeElementWrapper.dataset.publicKey;
        const NEWSLETTER_LIST_ID =
          notifyMeElementWrapper.dataset.newsletterListId;

        const emailInput = notifyMeElementWrapper.querySelector(
          'input[type="email"]',
        );
        const emailValue = emailInput.value;

        const variantIdInput = notifyMeElementWrapper.querySelector(
          'input[name="variantId"]',
        );
        const variantId = variantIdInput.value;

        const options = {
          method: "POST",
          headers: {
            revision: "2024-02-15",
            "content-type": "application/json",
          },
          body: JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                channels: ["EMAIL"],
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: emailValue,
                    },
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        };

        const messageElement = document.createElement("p");
        messageElement.classList.add("message");
        notifyMeElementWrapper.appendChild(messageElement);
        // Send the request to the Klaviyo API
        fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${PUBLIC_API_KEY}`,
          options,
        )
          .then((response) => {
            if (response.status === 202) {
              messageElement.textContent =
                window.theme.strings.notifyMe.successMessage;
              messageElement.classList.add("is-success");
            }
          })
          .catch((err) => {
            console.log("err", err);
            messageElement.textContent = err.message;
            messageElement.classList.add("is-error");
          });

        if (NEWSLETTER_LIST_ID) {
          const newsletterOptions = {
            method: "POST",
            headers: {
              revision: "2024-02-15",
              "content-type": "application/json",
            },
            body: JSON.stringify({
              data: {
                type: "subscription",
                attributes: {
                  custom_source: "Back in stock subscription",
                  profile: {
                    data: {
                      type: "profile",
                      attributes: {
                        email: emailValue,
                      },
                    },
                  },
                },
                relationships: {
                  list: {
                    data: {
                      type: "list",
                      id: NEWSLETTER_LIST_ID,
                    },
                  },
                },
              },
            }),
          };

          fetch(
            `https://a.klaviyo.com/client/subscriptions/?company_id=${PUBLIC_API_KEY}`,
            newsletterOptions,
          );
        }
      }

      handleNotifyFormInput(evt) {
        const { target } = evt;

        const errorField = target.closest(".field");
        if (!errorField) return;

        const errorMessage = errorField.querySelector(".error-message");
        if (!errorMessage) return;

        const submitButton = target
          ?.closest("form")
          ?.querySelector('button[type="submit"]');

        if (target.validity.valid) {
          errorField.classList.remove("has-error");
          target.classList.remove("invalid");
          errorMessage.textContent = "";
          submitButton?.removeAttribute("disabled");
        } else {
          errorField.classList.add("has-error");
          target.classList.add("invalid");
          errorMessage.textContent = target.validationMessage;
          submitButton?.setAttribute("disabled", "disabled");
        }
      }

      getSectionsToRender() {
        return [
          {
            id: "Cart",
            section: "main-cart",
            selector: ".thb-cart-form",
          },
          {
            id: "Cart-Drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          },
          {
            id: "cart-drawer-toggle",
            section: "cart-bubble",
            selector: ".thb-item-count",
          },
        ];
      }
      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });

        if (typeof CartDrawer !== "undefined") {
          new CartDrawer();
        }
        if (typeof Cart !== "undefined") {
          new Cart().renderContents(parsedState);
        }

        let product_drawer = document.getElementById("Product-Drawer");
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer
            .querySelector(".product-quick-images--container")
            .classList.remove("active");
          document.body.classList.remove("open-quick-view");

          if (window.innerWidth < 1069) {
            product_drawer.classList.remove("active");
            if (document.getElementById("Cart-Drawer")) {
              document.getElementById("Cart-Drawer").classList.add("active");
              document.body.classList.add("open-cart");
              document
                .getElementById("Cart-Drawer")
                .querySelector(".product-recommendations--full")
                .classList.add("active");
              dispatchCustomEvent("cart-drawer:open");
            }
          } else {
            product_drawer
              .querySelector(".product-quick-images--container")
              .addEventListener("transitionend", function () {
                product_drawer.classList.remove("active");

                if (document.getElementById("Cart-Drawer")) {
                  document
                    .getElementById("Cart-Drawer")
                    .classList.add("active");
                  document.body.classList.add("open-cart");
                  document
                    .getElementById("Cart-Drawer")
                    .querySelector(".product-recommendations--full")
                    .classList.add("active");
                  dispatchCustomEvent("cart-drawer:open");
                }
              });
          }

          if (!document.getElementById("Cart-Drawer")) {
            document.body.classList.remove("open-cc");
          }
        } else if (document.getElementById("Cart-Drawer")) {
          document.body.classList.add("open-cc");
          document.body.classList.add("open-cart");
          document.getElementById("Cart-Drawer").classList.add("active");
          dispatchCustomEvent("cart-drawer:open");
        }
      }
      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get("product-add-to-cart-sticky")) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled =
        document.body.classList.contains("animations-true") &&
        typeof gsap !== "undefined";
    }
    connectedCallback() {
      this.setupObservers();
    }

    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach((entry) => {
              if (entry.target === footer) {
                if (entry.intersectionRatio > 0) {
                  _this.classList.remove("sticky--visible");
                } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                  _this.classList.add("sticky--visible");
                }
              }
              if (entry.target === form) {
                let boundingRect = form.getBoundingClientRect();

                if (
                  entry.intersectionRatio === 0 &&
                  window.scrollY > boundingRect.top + boundingRect.height
                ) {
                  _this.formPassed = true;
                  _this.classList.add("sticky--visible");
                } else if (entry.intersectionRatio === 1) {
                  _this.formPassed = false;
                  _this.classList.remove("sticky--visible");
                }
              }
            });
          },
          {
            threshold: [0, 1],
          },
        ),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById("footer");
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define("product-add-to-cart-sticky", ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get("side-panel-links")) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll("button");
      this.drawer = document.getElementById("Product-Information-Drawer");
      this.buttons = this.drawer.querySelector(".side-panel-content--tabs");
      this.panels = this.drawer
        .querySelector(".side-panel-content--inner")
        .querySelectorAll(".side-panel-content--tab-panel");
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {}
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.body.classList.add("open-cc");
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add("active");
        });
      });
    }
  }

  customElements.define("side-panel-links", ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}
